import './CopyrightNotice.css';

// Copyright line at the very top of every logged-in tool page (above the
// TopBar). Mounted by ProtectedRoute, so it never appears on the public
// landing page, login or password reset.
const CopyrightNotice = () => (
  <div className="ut-copyright">
    Copyright Maestro Design &amp; Management AB 2026. All rights reserved.
  </div>
);

export default CopyrightNotice;
